/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2022-2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
export const actions = {
  SET_MACHINE_FILTER: 'SET_MACHINE_FILTER',
  SET_COMMON_FILTER: 'SET_COMMON_FILTER',
  SET_SOFTWARE_FILTER: 'SET_SOFTWARE_FILTER',
  SET_MACHINES: 'SET_MACHINES',
  SET_SOFTWARE_FAVOURITES: 'SET_SOFTWARE_FAVOURITES',
  SET_SOFTWARE_FAVOURITE: 'SET_SOFTWARE_FAVOURITE',
  SET_MACHINE_FAVOURITES: 'SET_MCHINE_FAVOURITES', // < Still required? Seems to unused
  SET_MACHINE_FAVOURITE: 'SET_MACHINE_FAVOURITE',
  UPDATE_MACHINES: 'UPDATE_MACHINES',
  UPDATE_ONLINE_MACHINES: 'UPDATE_ONLINE_MACHINES',
  UPDATE_FAULTY_MACHINES: 'UPDATE_FAULTY_MACHINES',
  LOAD_MACHINES_ERROR: 'LOAD_MACHINES_ERROR',
  LOAD_SOFTWARE_SUCCESS: 'LOAD_SOFTWARE_SUCCESS',
  LOAD_SOFTWARE_ERROR: 'LOAD_SOFTWARE_ERROR',
  LOAD_SOFTWARES_SUCCESS: 'LOAD_SOFTWARES_SUCCESS',
  LOAD_SOFTWARES_ERROR: 'LOAD_SOFTWARES_ERROR',
  LOAD_FAIRS_ERROR: 'LOAD_FAIRS_ERROR',
  LOAD_FAIRS_SUCCESS: 'LOAD_FAIRS_SUCCESS',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  LOAD_USER_ERROR: 'LOAD_USER_ERROR',
  LOAD_USER_SUCCESS: 'LOAD_USER_SUCCESS',
  FETCH_BUCKET_AVAILABLILITY_ERROR: 'FETCH_BUCKET_AVAILABLILITY_ERROR',
  FETCH_BUCKET_AVAILABLILITY: 'FETCH_BUCKET_AVAILABLILIY',
};
